import React from "react";
import "./Banner.css";

export const Banner = () => {
	return (
		<article className="choose">
			<h2>Choose among the Best!</h2>
		</article>
	);
};
